<cc-box>
  <div content box class="wrapper">

    <p translate class="text">ONBOARDING.FOOTER_TEXT</p>

    <div class="actions-wrapper">
      <button
        (click)="startChat()"
        mat-raised-button
        type="button"
        color="info-full"
      >{{'ONBOARDING.CHAT_ACTION' | translate}}
      </button>

      <button
        (click)="scheduleDemo()"
        mat-raised-button
        type="button"
        color="primary-full"
      >{{'ONBOARDING.DEMO_ACTION' | translate}}
      </button>
    </div>
  </div>
</cc-box>
